const PREFIX = "aiAgent.draft";

function getStorage() {
  try {
    return typeof window === "undefined" ? null : window.sessionStorage || null;
  } catch {
    return null;
  }
}

function safeJsonParse(raw) {
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getAiAgentDraftScope() {
  if (typeof window === "undefined") return "current";

  try {
    return (
      window.localStorage.getItem("sa_selectedBusinessId") ||
      window.localStorage.getItem("businessId") ||
      "current"
    );
  } catch {
    return "current";
  }
}

export function aiAgentDraftKey(name, scope) {
  if (scope) {
    if (!scope.businessId || !scope.userId) return null;
    return `${PREFIX}.${encodeURIComponent(scope.businessId)}.${encodeURIComponent(scope.userId)}.${name}`;
  }
  return `${PREFIX}.${getAiAgentDraftScope()}.${name}`;
}

export function readAiAgentDraft(name, scope) {
  const storage = getStorage();
  const key = aiAgentDraftKey(name, scope);
  if (!storage || !key) return null;
  try {
    const draft = safeJsonParse(storage.getItem(key));
    if (scope && (draft?.scope?.businessId !== scope.businessId || draft?.scope?.userId !== scope.userId)) return null;
    return draft;
  } catch {
    return null;
  }
}

export function writeAiAgentDraft(name, value, scope) {
  const storage = getStorage();
  const key = aiAgentDraftKey(name, scope);
  if (!storage || !key) return false;

  try {
    storage.setItem(
      key,
      JSON.stringify({ ...value, ...(scope ? { scope } : {}), savedAtUtc: new Date().toISOString() })
    );
    return true;
  } catch {
    // Ignore browser storage quota/security errors; backend save remains source of truth.
    return false;
  }
}

export function removeAiAgentDraft(name, scope) {
  const storage = getStorage();
  const key = aiAgentDraftKey(name, scope);
  if (!storage || !key) return;

  try {
    storage.removeItem(key);
  } catch {
    // Ignore browser storage errors.
  }
}
